import { instanceOfClass } from "./instanceOfClass";
import { instanceOfInterface } from "./instanceOfInterface";

export function instanceOf<T>(instance: any, type: string): instance is T {
  return instanceOfInterface(instance, type) || instanceOfClass(instance, type);
}
